<template>
  <div class="date-main">
    <el-date-picker
      v-model="rong.day1"
      value-format="timestamp"
      type="datetime"
      :placeholder="lan.c_start"
      @change="getTime1"
      class="dateinput"
    ></el-date-picker>
    <span class="to">to</span>
    <el-date-picker
      v-model="rong.day2"
      value-format="timestamp"
      type="datetime"
      :placeholder="lan.c_end"
      @change="gethistory"
      class="dateinput"
    ></el-date-picker>
    <div :class="common.language == 'cn'?'refresh':'refreshen'">
      <img src="../../assets/image/refresh.png" />
      <span @click="reset">{{lan.c_reset}}</span>
    </div>
    <span class="download" @click="download">{{lan.c_download}}</span>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      // day1: "",
      // day2: ""
    };
  },
  computed: {
    ...mapState(["rong", "login", "common"]),
    ...mapGetters({ lan: "common/lan" })
  },
  components: {},
  methods: {
    ...mapMutations({
      showHistory_s_r: "rong/showHistory_s_r",
      showHistory_g_r: "rong/showHistory_g_r",
      download_s_Ry: "rong/download_s_Ry",
      getStart: "rong/getStart",
      getEnd: "rong/getEnd",
      download_g_Ry: "rong/download_g_Ry",
      initNum: "rong/initNum",
      compareTime:'rong/compareTime'
    }),
    gethistory(val) {
      // console.log(this.rong.day1,this.rong.day2,'day')
      
      this.compareTime();//对比两次选择的时间
      this.getEnd(val);
      // console.log(this.day1,this.day2)
      let params = {
        userId: this.login.userInfo.itcode,
        recvId: this.rong.recvID,
        currIndex: "",
        pageSize: "",
        startTime: this.rong.day1,
        endTime: this.rong.day2
      };

      if (this.rong.downtype == "PERSON") {
        this.showHistory_s_r(params);
      }
      if (this.rong.downtype == "GROUP") {
        this.showHistory_g_r(params);
      }
    },
    download() {
      let params = {
        userId: this.login.userInfo.itcode,
        recvId: this.rong.recvID,
        startTime: this.rong.startTime,
        endTime: this.rong.endTime
      };

      if (this.rong.downtype == "PERSON") {
        this.download_s_Ry(params);
      }
      if (this.rong.downtype == "GROUP") {
        this.download_g_Ry(params);
      }
    },
    getTime1(val) {
      this.getStart(val);
    },
    reset() {
      this.rong.day1 = "";
      this.rong.day2 = "";
      let today = new Date().getTime();
      this.rong.startTime = 0;
      this.rong.endTime = today;
      this.initNum();
      let params = {
        userId: this.login.userInfo.itcode,
        recvId: this.rong.recvID,
        currIndex: "",
        pageSize: "",
        startTime: 0,
        endTime: today
      };
      // console.log(this.rong.downtype)

      if (this.rong.downtype == "PERSON") {
        this.showHistory_s_r(params);
      }
      if (this.rong.downtype == "GROUP") {
        this.showHistory_g_r(params);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.date-main {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  padding-left: 70px;
  padding-right: 35px;
  // width: 100%;
  .to {
    font-size: 20px;
    font-family: PingFangSC;
    color: rgba(58, 58, 58, 1);
    margin: 0 7px;
  }
  .refresh {
    cursor: pointer;
    display: flex;
    align-items: center;
    // text-align: center;
    padding-left: 19px;
    width: 90px;
    height: 37px;
    // line-height: 37px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    font-size: 14px;
    font-family: PingFangSC;
    // box-sizing: border-box;
    color: rgba(74, 74, 74, 1);
    margin-left: 21px;
    img {
      width: 12px;
      height: 13px;
      margin-right: 7px;
    }
  }
  .refreshen {
    cursor: pointer;
    display: flex;
    align-items: center;
    // text-align: center;
    padding-left: 16px;
    width: 90px;
    height: 37px;
    // line-height: 37px;
    border-radius: 4px;
    border: 1px solid rgba(151, 151, 151, 1);
    font-size: 14px;
    font-family: PingFangSC;
    // box-sizing: border-box;
    color: rgba(74, 74, 74, 1);
    margin-left: 21px;
    img {
      width: 12px;
      height: 13px;
      margin-right: 7px;
    }
  }
  .download {
    cursor: pointer;
    text-align: center;
    width: 107px;
    height: 40px;
    line-height: 40px;
    margin-left: 410px;
    // padding-top: 10px;
    background: rgba(216, 216, 216, 1)
      linear-gradient(
        270deg,
        rgba(69, 176, 220, 1) 0%,
        rgba(109, 159, 239, 1) 100%
      );
    // box-shadow: 2px 2px 0px 0px rgba(68, 176, 220, 0.15);
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/rong/HistoryDate.vue